module.exports = __webpack_public_path__ + "img/reading__books.69821ce0.svg";